import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const MobileAppIcon = createValidIcon((props) => {
  const { disabled, size = 40 } = props

  if (disabled) {
    return (
      <svg
        width={size}
        height={size}
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z'
          fill='#494949'
        />
        <path
          d='M21.513 24.8487H17.5986C17.1236 24.8487 16.6844 24.5952 16.4468 24.1837L14.1975 20.2879C13.9599 19.8764 13.9599 19.3693 14.1975 18.9579L16.4468 15.0619C16.6844 14.6504 17.1236 14.3969 17.5986 14.3969H21.5112L24.6194 9.01319C24.5531 9.00829 24.4873 9 24.4201 9H15.2757C14.3097 9 13.4174 9.51533 12.9344 10.3518L8.36209 18.271C7.8793 19.1075 7.8793 20.1382 8.36209 20.9747L12.9344 28.8941C13.4174 29.7305 14.3098 30.2457 15.2757 30.2457H24.4201C24.4879 30.2457 24.5545 30.2374 24.6213 30.2324L21.5131 24.8488L21.513 24.8487Z'
          fill='white'
        />
        <path
          d='M31.3337 18.2711L26.7614 10.3517C26.7275 10.293 26.6872 10.2396 26.6491 10.1841L23.5409 15.5676L25.4983 18.9578C25.7358 19.3693 25.7358 19.8764 25.4983 20.2878L23.5418 23.6765L26.6502 29.0602C26.6877 29.005 26.7278 28.9523 26.7614 28.8939L31.3337 20.9747C31.8167 20.1383 31.8167 19.1076 31.3337 18.2711Z'
          fill='#F9F9F9'
        />
      </svg>
    )
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 28 28'
      fill='none'
    >
      <path
        d='M15.2754 18.6797H11.5266C11.0714 18.6797 10.6507 18.4369 10.4238 18.0427L8.27006 14.3112C8.04314 13.9171 8.04314 13.4314 8.27006 13.0373L10.4238 9.30569C10.6507 8.91156 11.0714 8.66872 11.5266 8.66872H15.274L18.2505 3.51327C18.1868 3.50796 18.1245 3.5 18.0594 3.5H9.30248C8.37755 3.5 7.52295 3.99365 7.05982 4.79517L2.68067 12.3791C2.21755 13.1806 2.21755 14.1665 2.68067 14.9681L7.05982 22.5519C7.52295 23.3535 8.37755 23.8471 9.30248 23.8471H18.0594C18.1245 23.8471 18.1882 23.8391 18.2519 23.8338L15.2754 18.6784V18.6797Z'
        fill='#FF0044'
      />
      <path
        d='M24.6812 12.3804L20.3021 4.79649C20.2689 4.74076 20.2304 4.68901 20.1946 4.63593L17.2181 9.79138L19.0932 13.0386C19.3201 13.4327 19.3201 13.9184 19.0932 14.3125L17.2194 17.5584L20.1959 22.7138C20.2318 22.6608 20.2702 22.6103 20.3021 22.5546L24.6812 14.9707C25.1444 14.1692 25.1444 13.1832 24.6812 12.3817V12.3804Z'
        fill='#28F981'
      />
    </svg>
  )
})
